import { connect, mapReadPretty } from '@formily/react'

import { RichEditor as Editor } from '@eastcoal/editor/index'

export const RichEditor = connect(
  Editor,
  mapReadPretty(Editor, {
    toolbar: false,
    disabled: true,
    bordered: true
  })
)
